import React, {Fragment} from 'react'
import classNames from "classnames";
export function Table({ list, title }) {
  if (list.length === 0) {
    return null
  }

  const listRows = list.map((item, index) => {
    return (
      <Fragment key={index}>
        <div
          className={classNames('mtt-table-wrapper__item', {
            'mtt-table-wrapper__item--padding': index > 0
          })}
        >
          <span>{item.label}</span>
          <span>{item.value}</span>
        </div>

        {item.variants && item.variants.length > 0 && item.variants.map((variantItem, index) => (
          <div key={index} className='mtt-table-wrapper__item'>
            <span>- {variantItem.label}</span>
            <span>{variantItem.value}</span>
          </div>
        ))}
      </Fragment>
    )
  })

  return (
    <div className='mtt-table-wrapper'>
      <div className='mtt-table-wrapper__header'>{title}</div>
      {listRows}
    </div>
  )
}
